export default __webpack_public_path__ + "static/aave-b747f0c63b3cea0007f2ce0438a0ff87.png";